document.querySelectorAll('[data-review-gallery]').forEach((gallery) => {
  const dialog = gallery.querySelector('[data-review-dialog]');
  const cards = [...gallery.querySelectorAll('[data-review-item]')];
  const viewer = dialog.querySelector('[data-review-viewer]');
  const count = dialog.querySelector('[data-review-count]');
  const thumbs = dialog.querySelector('[data-review-thumbnails]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hoverEnabled = window.matchMedia('(hover: hover)');
  let active = 0;
  let selected = 0;
  let startX = 0;
  let dragged = false;
  let inView = false;
  let pauseUntil = 0;
  let lastFrame = 0;
  const rotate = (index) => {
    active = (index + cards.length) % cards.length;
    cards.forEach((card, i) => {
      let position = i - active;
      if (position > cards.length / 2) position -= cards.length;
      if (position < -cards.length / 2) position += cards.length;
      const distance = Math.abs(position);
      card.style.setProperty('--position', position);
      card.style.setProperty('--distance', distance);
      card.style.zIndex = Math.round(100 - distance * 10);
      card.style.opacity = Math.max(0, 1 - distance / 1.5);
      card.style.pointerEvents = distance < 1.4 ? 'auto' : 'none';
      card.tabIndex = distance < 1.4 ? 0 : -1;
      card.toggleAttribute('aria-current', distance < 0.5);
    });
  };
  const show = (index) => {
    selected = (index + cards.length) % cards.length;
    viewer.replaceChildren(cards[selected].firstElementChild.cloneNode(true));
    count.textContent = `Customer message ${selected + 1} of ${cards.length}`;
    [...thumbs.children].forEach((thumb, i) => thumb.toggleAttribute('aria-current', i === selected));
  };
  cards.forEach((card, index) => {
    const thumb = document.createElement('button');
    thumb.type = 'button'; thumb.textContent = String(index + 1);
    thumb.setAttribute('aria-label', `Show customer review ${index + 1}`);
    thumb.addEventListener('click', () => show(index)); thumbs.append(thumb);
    card.addEventListener('click', () => {
      if (dragged) return;
      pauseUntil = Date.now() + 10000;
      if (Math.min(Math.abs(index - active), cards.length - Math.abs(index - active)) > 0.5) return rotate(index);
      show(index); dialog.showModal();
    });
  });
  rotate(0);
  gallery.addEventListener('pointerdown', (event) => { if (dialog.contains(event.target)) return; startX = event.clientX; dragged = false; pauseUntil = Date.now() + 10000; });
  gallery.addEventListener('pointermove', (event) => { if (event.buttons && Math.abs(event.clientX - startX) > 8) dragged = true; });
  gallery.addEventListener('pointerup', (event) => {
    if (dialog.contains(event.target)) return;
    const distance = event.clientX - startX;
    if (Math.abs(distance) > 45) rotate(active + (distance < 0 ? 1 : -1));
    setTimeout(() => { dragged = false; });
  });
  gallery.addEventListener('keydown', (event) => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault(); rotate(active + (event.key === 'ArrowRight' ? 1 : -1));
    pauseUntil = Date.now() + 10000;
  });
  new IntersectionObserver(([entry]) => { inView = entry.isIntersecting; }, { threshold: 0.5 }).observe(gallery);
  const animate = (time) => {
    if (!gallery.isConnected) return;
    if (lastFrame && inView && !document.hidden && !reducedMotion.matches && !dialog.open && Date.now() > pauseUntil && !(hoverEnabled.matches && gallery.matches(':hover'))) rotate(active + Math.min(time - lastFrame, 50) / 3800);
    lastFrame = time;
    requestAnimationFrame(animate);
  };
  requestAnimationFrame(animate);
  dialog.querySelector('[data-review-close]').addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-review-prev]').addEventListener('click', () => show(selected - 1));
  dialog.querySelector('[data-review-next]').addEventListener('click', () => show(selected + 1));
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
});
